import { render, staticRenderFns } from "./ButtonOption.vue?vue&type=template&id=652a9414&lang=pug"
import script from "./ButtonOption.vue?vue&type=script&lang=js"
export * from "./ButtonOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports